import React from "react";

export default function MassageError({ children }) {
  return <div className=" massage-error">{children}</div>;
}
